module.exports = __webpack_public_path__ + "static/media/archlinux.05177b6c.svg";